import { Configuration, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

export interface EntraClientConfig {
  clientId: string;
  authority: string;
  apiScope: string;
}

export const msalConfigFor = ({ clientId, authority }: EntraClientConfig): Configuration => ({
  auth: {
    clientId,
    authority,
    redirectUri: `${window.location.origin}/login/callback`,
    // Entra checks this against the app registration's redirect URIs too, so the origin is registered there.
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage'
  }
});

export const createMsalInstance = async (entra: EntraClientConfig): Promise<IPublicClientApplication> => {
  const instance = new PublicClientApplication(msalConfigFor(entra));
  await instance.initialize();
  return instance;
};
